<template>
  <RevDrawer
    :name="MODAL_NAMES.TRADE_IN"
    :title="i18n(translations.modalTitle)"
  >
    <template #body>
      <h2 class="heading-1 mb-24">
        {{ i18n(translations.title) }}
      </h2>

      <ContentRow
        class="!mb-20"
        :labels="[i18n(translations.item1Description)]"
        :title="i18n(translations.item1Label)"
      >
        <IconBadge />
      </ContentRow>

      <RevDivider class="my-20" />

      <ContentRow
        class="!mb-20 mt-0"
        header-tag="h3"
        :labels="[i18n(translations.item2Description)]"
        :title="i18n(translations.item2Label)"
      >
        <IconShoppingBag />
      </ContentRow>

      <RevDivider class="my-20" />

      <ContentRow
        class="!mb-20 mt-0"
        header-tag="h3"
        :labels="[i18n(translations.item3Description)]"
        :title="i18n(translations.item3Label)"
      >
        <IconPackage />
      </ContentRow>

      <RevDivider class="my-20" />

      <ContentRow
        class="!mb-20 mt-0"
        header-tag="h3"
        :labels="[i18n(translations.item4Description)]"
        :title="i18n(translations.item4Label)"
      >
        <IconMoney />
      </ContentRow>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import ContentRow from '@backmarket/nuxt-layer-product-modals/ContentRow.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'
import { RevDrawer } from '@ds/components/Drawer'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './TradeInModal.translations'

const i18n = useI18n()
</script>
